function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { themes } from "segments/segments-service";
import AssetComponent from "/components/core/asset/asset-component";
import { trackEvent } from "/services/bigbrain-service";
import { LIVE_BOARD_PARALLAX_ASSET_CLICKED, ASSET_COMPONENT_VIDEO_STARTED } from "constants/bigbrain-event-types";
import { StyledSideBySideTextAndAsset } from "./side-by-side-text-and-asset.scss";
import DefaultProps from "./default-props";
const FULL_WIDTH = "100%";
class SideBySideTextAndAsset extends PureComponent {
    getLeftSpaceStyle() {
        const { background } = this.props;
        const { color, width } = background;
        if (!width) return {};
        const themeStyles = themes[color];
        return _object_spread({}, themeStyles);
    }
    getBackgroundStyle() {
        const { background, swapTextAndAssetPosition, spaceBetweenTextAndAsset } = this.props;
        const { width, color, verticalPadding } = background;
        let backgroundStyle = verticalPadding ? {
            paddingBottom: verticalPadding,
            paddingTop: verticalPadding
        } : {};
        const themeStyles = themes[color];
        if (!width || !themeStyles) return backgroundStyle;
        const direction = swapTextAndAssetPosition ? "left" : "right";
        backgroundStyle = _object_spread_props(_object_spread({}, backgroundStyle), {
            background: `linear-gradient(to ${direction}, ${themeStyles.background} ${width}, white 0)`,
            color: themeStyles.color,
            gap: spaceBetweenTextAndAsset
        });
        return backgroundStyle;
    }
    getContentStyle() {
        const { spaceBetweenTextAndAsset, mobileSpaceBetweenTextAndAsset } = this.props;
        const backgroundStyle = this.getBackgroundStyle();
        return _object_spread({
            "--space-between-text-and-asset": spaceBetweenTextAndAsset,
            "--mobile-space-between-text-and-asset": mobileSpaceBetweenTextAndAsset || 0
        }, backgroundStyle);
    }
    getSideBySideComponentStyle() {
        var _background_backgroundImage;
        const { background } = this.props;
        const backgroundImage = background === null || background === void 0 ? void 0 : (_background_backgroundImage = background.backgroundImage) === null || _background_backgroundImage === void 0 ? void 0 : _background_backgroundImage.src;
        if (backgroundImage) {
            var _background_backgroundImage1;
            return {
                background: `url(${backgroundImage})`,
                backgroundPosition: (background === null || background === void 0 ? void 0 : (_background_backgroundImage1 = background.backgroundImage) === null || _background_backgroundImage1 === void 0 ? void 0 : _background_backgroundImage1.backgroundPosition) || "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover"
            };
        }
        return null;
    }
    getRightSpaceStyle() {
        const { background } = this.props;
        const { width, color } = background;
        const themeStyles = themes[color];
        if (!themeStyles) return {};
        return {
            backgroundColor: width === FULL_WIDTH ? themeStyles.background : undefined
        };
    }
    render() {
        const { replaceTextComponent, replaceTextComponentProps, contentClassName, fullParagraph, asset, swapTextAndAssetPosition, mobileSwapTextAndAssetPosition, background, alignToLogo, paragraphVerticalAlignment, alignImageToScreenEdge, hideParagraph, nestedBoardItems } = this.props;
        const { addLiveBoardTextAndAsset, parallaxAsset, gapBetweenAssets } = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {};
        const parallaxAssetExists = this.assetExist(parallaxAsset);
        const leftSpaceStyle = swapTextAndAssetPosition ? this.getRightSpaceStyle() : this.getLeftSpaceStyle();
        const contentStyle = this.getContentStyle();
        const sideBySideComponentStyle = this.getSideBySideComponentStyle();
        const rightSpaceStyle = swapTextAndAssetPosition ? this.getLeftSpaceStyle() : this.getRightSpaceStyle();
        const ReplaceTextComponent = replaceTextComponent || FullParagraph;
        const { width } = background;
        const isFullWidth = width === FULL_WIDTH;
        const renderImage = (image, index)=>{
            return /*#__PURE__*/ _jsx("div", {
                className: classnames("image-wrapper", asset === null || asset === void 0 ? void 0 : asset.position, (asset === null || asset === void 0 ? void 0 : asset.shadow) && "with-shadow", parallaxAssetExists && "inside-parallax"),
                onClick: addLiveBoardTextAndAsset ? ()=>this.imageClicked(index) : null,
                style: this.getImageWrapperStyle(),
                children: this.renderAsset(image)
            });
        };
        const assetsToRenderForParallax = [
            asset,
            parallaxAsset
        ];
        return /*#__PURE__*/ _jsxs(StyledSideBySideTextAndAsset, {
            className: classnames("side-by-side-text-and-asset", {
                "align-image-to-screen-edge": alignImageToScreenEdge,
                "is-swap": swapTextAndAssetPosition,
                "is-mobile-swap": mobileSwapTextAndAssetPosition
            }),
            style: sideBySideComponentStyle,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "left-space",
                    style: leftSpaceStyle
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: classnames("side-by-side-content", paragraphVerticalAlignment, contentClassName, {
                        "is-swap": swapTextAndAssetPosition,
                        "is-mobile-swap": mobileSwapTextAndAssetPosition,
                        "is-full-width": isFullWidth,
                        "align-to-logo": !!alignToLogo,
                        "no-text-component": hideParagraph,
                        "add-live-board-experience": addLiveBoardTextAndAsset
                    }),
                    style: contentStyle,
                    children: [
                        !hideParagraph && /*#__PURE__*/ _jsx("div", {
                            className: classnames("full-paragraph-component-wrapper", parallaxAssetExists && "sticky"),
                            style: this.getFullParagraphComponentStyle(),
                            children: /*#__PURE__*/ _jsx(ReplaceTextComponent, _object_spread_props(_object_spread({}, replaceTextComponentProps, fullParagraph, this.getReplaceTextProps()), {
                                openLiveBoardExperience: addLiveBoardTextAndAsset ? this.openLiveBoardExperience : null
                            }))
                        }),
                        parallaxAssetExists ? /*#__PURE__*/ _jsx("div", {
                            className: "parallax-wrapper",
                            style: {
                                gap: gapBetweenAssets
                            },
                            children: assetsToRenderForParallax.map((image, index)=>renderImage(image, index))
                        }) : renderImage(asset)
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "right-space",
                    style: rightSpaceStyle
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "assetExist", (asset)=>{
            var _asset_image, _asset_video;
            return (asset === null || asset === void 0 ? void 0 : (_asset_image = asset.image) === null || _asset_image === void 0 ? void 0 : _asset_image.src) || (asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : _asset_video.src);
        });
        _define_property(this, "onVideoStart", ()=>{
            var _asset_video_src_formats, _asset_video_src, _asset_video;
            const { asset } = this.props;
            trackEvent(ASSET_COMPONENT_VIDEO_STARTED, {
                info1: asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : (_asset_video_src = _asset_video.src) === null || _asset_video_src === void 0 ? void 0 : (_asset_video_src_formats = _asset_video_src.formats) === null || _asset_video_src_formats === void 0 ? void 0 : _asset_video_src_formats[0]
            });
        });
        _define_property(this, "renderAsset", (asset)=>{
            const { replaceAssetComponent: ReplaceAssetComponent, replaceAssetComponentProps, assetQuality, useDynamicAsset, hideControls, useWindowMask, dynamicAssetParamPath } = this.props;
            if (ReplaceAssetComponent) {
                return /*#__PURE__*/ _jsx(ReplaceAssetComponent, _object_spread({}, replaceAssetComponentProps));
            }
            const { fitToContainer, assetHeight } = asset, assetRestProps = _object_without_properties(asset, [
                "fitToContainer",
                "assetHeight"
            ]);
            const assetClassName = classnames("side-by-side-asset", {
                "ignore-parent-height": !fitToContainer
            });
            return /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, assetRestProps), {
                assetQuality: assetQuality,
                useDynamicAsset: useDynamicAsset,
                hideControls: hideControls,
                useWindowMask: useWindowMask,
                dynamicAssetParamPath: dynamicAssetParamPath,
                convertGifToVideo: true,
                className: assetClassName,
                imageClassName: "text-and-asset-image",
                style: {
                    height: assetHeight
                },
                onStart: this.onVideoStart
            }));
        });
        _define_property(this, "getFullParagraphComponentStyle", ()=>{
            const { leftSizeWidth, nestedBoardItems } = this.props;
            const { fullParagraphMarginTop, fullParagraphMarginBottom, fullParagraphDistanceFromTop, parallaxAsset } = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {};
            let styleObj = {
                width: leftSizeWidth,
                marginTop: fullParagraphMarginTop,
                marginBottom: fullParagraphMarginBottom
            };
            if (this.assetExist(parallaxAsset)) {
                styleObj = _object_spread_props(_object_spread({}, styleObj), {
                    top: fullParagraphDistanceFromTop
                });
            }
            return styleObj;
        });
        _define_property(this, "getImageWrapperStyle", ()=>{
            const { rightSizeWidth, allowImageOverflow } = this.props;
            let style = {
                width: rightSizeWidth
            };
            if (allowImageOverflow) {
                style = _object_spread_props(_object_spread({}, style), {
                    overflow: "visible"
                });
            }
            return style;
        });
        _define_property(this, "openLiveBoardExperience", ()=>{
            const { nestedBoardItems, openLiveBoard } = this.props;
            const { boardBannerText, embeddedBoardTitle, addSecondLiveBoardSignUpButton, liveBoardToolTipText } = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {};
            openLiveBoard({
                boardBannerText,
                embeddedBoardTitle,
                addSecondLiveBoardSignUpButton,
                liveBoardToolTipText
            });
        });
        _define_property(this, "imageClicked", (index)=>{
            trackEvent(LIVE_BOARD_PARALLAX_ASSET_CLICKED, {
                kind: index !== undefined ? index : null
            });
            this.openLiveBoardExperience();
        });
        _define_property(this, "getReplaceTextProps", ()=>{
            const { bulletsConfig, iconsConfig, titleSize, textSize, spaceFromParagraph, withDynamicParagraphTitle, withDynamicParagraphSubtitle, topicBottomMargin, buttonTopMargin } = this.props;
            const replaceTextProps = {};
            if (bulletsConfig) replaceTextProps.bulletsConfig = bulletsConfig;
            if (iconsConfig) replaceTextProps.iconsConfig = iconsConfig;
            if (titleSize) replaceTextProps.titleSize = titleSize;
            if (textSize) replaceTextProps.textSize = textSize;
            if (spaceFromParagraph) replaceTextProps.spaceFromParagraph = spaceFromParagraph;
            if (withDynamicParagraphTitle) replaceTextProps.withDynamicParagraphTitle = withDynamicParagraphTitle;
            if (withDynamicParagraphSubtitle) replaceTextProps.withDynamicParagraphSubtitle = withDynamicParagraphSubtitle;
            if (topicBottomMargin) replaceTextProps.topicBottomMargin = topicBottomMargin;
            if (buttonTopMargin) replaceTextProps.buttonTopMargin = buttonTopMargin;
            return replaceTextProps;
        });
    }
}
export { SideBySideTextAndAsset as default };
SideBySideTextAndAsset.defaultProps = DefaultProps;
